module.exports = __webpack_public_path__ + "static/img/congfazi.8498851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/congfazi.jpg
// module id = ObG8
// module chunks = 1